if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.showLoader = this.getAttribute("data-show-loader")
        this.atcText = this.submitButton.querySelector(".atc-text");
        this.atcTextPrice = this.submitButton.querySelector(".atc-text-price");
        this.diwaliCollectionProduct = this.dataset.diwaliCollectionProduct;
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        console.log(this.submitButton);
        this.previousCartValue = 0 ;

        if (document.querySelector(".totals__subtotal-value")) {
          this.previousCartValue = document.querySelector(".totals__subtotal-value").innerHTML;
        }
        
        const quantid = this.submitButton.getAttribute("data-cart-quantity");
        const variantId =  Number(quantid);
        fetch("/cart.js")
          .then((res) => res.json())
          .then((res) => {
            if (res.items && res.items.length > 0) {
              const matchingItems = res.items.filter(item => item.variant_id == variantId);
              const totalQuantity = matchingItems.reduce((total, item) => total + item.quantity, 0);
              if (totalQuantity >= 4) {
                alert("You can only Add 4 items");
              } else {
                if (this.submitButton.getAttribute("aria-disabled") === "true")
                  return;

                this.handleErrorMessage();

                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.classList.add("loading");
                if (this.showLoader == 'true'){
                  this.atcText.classList.add("hidden");
                  this.querySelector(".loading-overlay__spinner")?.classList.remove("hidden")
                }
                else if (this.atcText) {
                  this.atcText.textContent = "Adding";
                  if (this.atcTextPrice) {
                    this.atcTextPrice.classList.add("hidden");
                  }
                }

                const config = fetchConfig("javascript");
                config.headers["X-Requested-With"] = "XMLHttpRequest";
                delete config.headers["Content-Type"];

                const formData = new FormData(this.form);

                for (let i = 1; i <= 7; i++) {
                  const attr = `data-special-product_${i}`;
                  if (this.getAttribute(attr)) {
                    formData.append(`properties[special-product_${i}]`, "true");
                    break;
                  }
                }

                if (this.diwaliCollectionProduct === "true") {
                  formData.append("properties[diwaliCollectionProduct]", "true");
                }

                if (this.cart) {
                  formData.append(
                    "sections",
                    this.cart.getSectionsToRender().map((section) => section.id)
                  );
                  formData.append("sections_url", window.location.pathname);
                  this.cart.setActiveElement(document.activeElement);
                }
                if (this.closest(".ec_product")) {
                  setTimeout(() => {
                    fetch("/cart.js")
                      .then((res) => res.json())
                      .then((res) =>
                        window.dataLayer.push({
                          event: "Empty cart upsell",
                          ProductTitle: res.items[0].title,
                          ProductPrice: res.items[0].presentment_price,
                          ProductSKU: res.items[0].sku,
                          ProductURL: `https://letshyphen.com/products${res.items[0].url}`,
                          clevertap: {
                            ProductTitle: res.items[0].title,
                            ProductSku: res.items[0].sku,
                            ProductPrice: res.items[0].presentment_price,
                            ProductUrl: `https://letshyphen.com/products${res.items[0].url}`,
                          },
                        })
                      );
                  }, 500);
                }
                config.body = formData;

                fetch(`${routes.cart_add_url}`, config)
                  .then((response) => response.json())
                  .then((response) => {
                    if (response.status) {
                      this.handleErrorMessage(response.description);

                      const soldOutMessage =
                        this.submitButton.querySelector(".sold-out-message");
                      if (!soldOutMessage) return;
                      this.submitButton.setAttribute("aria-disabled", true);
                      this.submitButton
                        .querySelector("span")
                        .classList.add("hidden");
                      soldOutMessage.classList.remove("hidden");
                      this.error = true;
                      return;
                    } else if (!this.cart) {
                      window.location = window.routes.cart_url;
                      return;
                    }

                    if (!this.error)
                      publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: "product-form",
                      });
                    this.error = false;
                    const quickAddModal = this.closest("quick-add-modal");
                    if (quickAddModal) {
                      document.body.addEventListener(
                        "modalClosed",
                        () => {
                          setTimeout(() => {
                            this.cart.renderContents(response);
                          });
                        },
                        { once: true }
                      );
                      quickAddModal.hide(true);
                    } else if (this.getAttribute("data-isPreOrder") == "true") { 
                      this.postPreeOrderSubmit();
                      this.submitPreOrder();
                      this.cart.renderContents(response,true);  
                    } else {
                      this.cart.renderContents(response);
                    }
                  })
                  .catch((e) => {
                    console.error(e);
                  })
                  .finally(() => {
                    this.submitButton.classList.remove("loading");
                    if (this.cart && this.cart.classList.contains("is-empty"))
                      this.cart.classList.remove("is-empty");
                    if (!this.error)
                      this.submitButton.removeAttribute("aria-disabled");
                      if (this.atcText) {
                        this.atcText.textContent = this.getAttribute("data-isPreOrder") === "true"
                          ? "PREORDER"
                          : "ADD TO CART"
                      }
                      if (this.atcText) {
                        const buttonLabel = this.getAttribute("data-button-label");
                        if (buttonLabel) {
                          this.atcText.innerHTML = buttonLabel;
                        }
                      }
                      if (this.atcTextPrice) {
                        this.atcTextPrice.classList.remove("hidden");
                      }
                      if (this.showLoader == 'true'){
                        this.atcText.classList.remove("hidden");
                        this.querySelector(".loading-overlay__spinner")?.classList.add("hidden")
                      }
                    this.submitAtcDatalayer(this,this.previousCartValue);
                  });
              }
            } else {
              if (this.submitButton.getAttribute("aria-disabled") === "true")
                return;

              this.handleErrorMessage();

              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.classList.add("loading");
              if (this.showLoader == 'true'){
                this.atcText.classList.add("hidden");
                this.querySelector(".loading-overlay__spinner")?.classList.remove("hidden")
              }
              else if (this.atcText) {
                this.atcText.textContent = "Adding";
                if (this.atcTextPrice) {
                  this.atcTextPrice.classList.add("hidden");
                }
              }

              const config = fetchConfig("javascript");
              config.headers["X-Requested-With"] = "XMLHttpRequest";
              delete config.headers["Content-Type"];

              const formData = new FormData(this.form);
              for (let i = 1; i <= 7; i++) {
                const attr = `data-special-product_${i}`;
                if (this.getAttribute(attr)) {
                  formData.append(`properties[special-product_${i}]`, "true");
                  break;
                }
              }

              if (this.diwaliCollectionProduct === "true") {
                formData.append("properties[diwaliCollectionProduct]", "true");
              }

              if (this.cart) {
                formData.append(
                  "sections",
                  this.cart.getSectionsToRender().map((section) => section.id)
                );
                formData.append("sections_url", window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
              }
              config.body = formData;

              fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    this.handleErrorMessage(response.description);

                    const soldOutMessage =
                      this.submitButton.querySelector(".sold-out-message");
                    if (!soldOutMessage) return;
                    this.submitButton.setAttribute("aria-disabled", true);
                    this.submitButton
                      .querySelector("span")
                      .classList.add("hidden");
                    soldOutMessage.classList.remove("hidden");
                    this.error = true;
                    return;
                  } else if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                  }

                  if (!this.error)
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                      source: "product-form",
                    });
                  this.error = false;
                  const quickAddModal = this.closest("quick-add-modal");
                  if (quickAddModal) {
                    document.body.addEventListener(
                      "modalClosed",
                      () => {
                        setTimeout(() => {
                          this.cart.renderContents(response);
                        });
                      },
                      { once: true }
                    );
                    quickAddModal.hide(true);
                  } else if (this.getAttribute("data-isPreOrder") == "true") { 
                    this.postPreeOrderSubmit();
                    this.submitPreOrder();
                    this.cart.renderContents(response,true); 
                  } else {
                    this.cart.renderContents(response);
                  }
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  this.submitButton.classList.remove("loading");
                  if (this.cart && this.cart.classList.contains("is-empty"))
                    this.cart.classList.remove("is-empty");
                  if (!this.error)
                    this.submitButton.removeAttribute("aria-disabled");
                  
                  this.submitAtcDatalayer(this,this.previousCartValue);
                  if (this.atcText) {
                    this.atcText.textContent = this.getAttribute("data-isPreOrder") === "true"
                      ? "PREORDER"
                      : "ADD TO CART"
                  }
                  if (this.atcText) {
                    const buttonLabel = this.getAttribute("data-button-label");
                    if (buttonLabel) {
                      this.atcText.innerHTML = buttonLabel;
                    }
                  }
                  if (this.atcTextPrice) {
                    this.atcTextPrice.classList.remove("hidden");
                  }
                  if (this.showLoader == 'true'){
                    this.atcText.classList.remove("hidden");
                    this.querySelector(".loading-overlay__spinner")?.classList.add("hidden")
                  }
                });
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      async submitPreOrder() {
        const apiUrl = "https://script.google.com/macros/s/AKfycbxVa5cabSQxKQen5kgpmlpVBKcDHKA9J9t-tf68KD-_9zB5BKv1Agx35-6v1PumgDeUtQ/exec";
        const preorderData = {
          'Name': this.getAttribute("data-customer-name") || 'NA',
          'Email': this.getAttribute("data-customer-email") || 'NA',
          'Phone Number': this.getAttribute("data-customer-phone") || 'NA',
          'Product Title': this.getAttribute("data-product-title") || '',
          'Product ID': this.getAttribute("data-productId") || '',
          'Variant ID': this.getAttribute("data-variantId") || '',
          'SKU ID': this.getAttribute("data-skuId") || '',
          'Date Of Interaction': this.getAttribute("data-interaction-date") || ''
        };

        try {
          const formData = new FormData();

          Object.entries(preorderData).forEach(([key, value]) => {
            formData.append(key, value);
          });
      
          const response = await fetch(apiUrl, {
            method: 'POST',
            body: formData
          });
      
          if (response.ok) {
            // console.log("Form submitted successfully");
          } else {
            console.error('Failed to submit the form. Please try again.');
          }
        } catch (error) {
          console.error('Error:', error);
        }
      }
      
      postPreeOrderSubmit(){
        const successMessage = document.querySelector('.preorder-me-success-message-popup');
        successMessage.classList.remove("inactive");
  
        setTimeout(() => {
          successMessage.classList.add("inactive");
        }, 4000);
  
        let clevertapData = {
          Product_Name: this.getAttribute("data-product-title") || '',
          Product_id: this.getAttribute("data-productId") || '',
          Variant_id: this.getAttribute("data-variantId") || '',
          Qty: document.querySelector(".quantity__input") ? document.querySelector(".quantity__input").value : '1',
          SKU: this.getAttribute("data-skuId") || '',
          Product_Link:this.getAttribute("data-product-link") || '',
          Date_Ordered: this.getAttribute("data-interaction-date") || '',
          Cart_Value:document.querySelector(".totals__subtotal-value").innerHTML || ''
        }
  
        dataLayer.push({
          event: "Pre-Order",
          Product_Name: this.getAttribute("data-product-title") || '',
          Product_id: this.getAttribute("data-productId") || '',
          Variant_id: this.getAttribute("data-variantId") || '',
          Qty: document.querySelector(".quantity__input") ? document.querySelector(".quantity__input").value : '1',
          SKU: this.getAttribute("data-skuId") || '',
          Product_Link:this.getAttribute("data-product-link") || '',
          Date_Ordered: this.getAttribute("data-interaction-date") || '',
          Cart_Value:document.querySelector(".totals__subtotal-value").innerHTML || '',
          clevertap : clevertapData
        });
      }

      submitAtcDatalayer(productForm,previousCartValue) {
        let cartValue = 0 ;
        let cartValueNumeric = 0;
        const subtotalEl = document.querySelector(".totals__subtotal-value");

        if (document.querySelector(".totals__subtotal-value")) {
          cartValue = document.querySelector(".totals__subtotal-value").innerHTML;
        }

        if (subtotalEl) {
          cartValueNumeric = Number(subtotalEl.dataset.cartvalue);
        }

        let clevertapData = {
          Section_Title: productForm.getAttribute("data-section-title"),
          Product_Name : productForm.getAttribute("data-product-title"), 
          Quantity : document.querySelector(".quantity__input").value || 1,
          Offer_Price : productForm.getAttribute("data-offer-price"),
          MRP : productForm.getAttribute("data-mrp"),
          Previous_Cart_Value : previousCartValue ,
          Current_Cart_Value : cartValue ,
          Product_Image : productForm.getAttribute("data-product-image"),
          Variant_id : productForm.getAttribute("data-variantid"),
          Product_id : productForm.getAttribute("data-productid")
        }

        dataLayer.push({
          event: "Add_To_Cart_Custom",
          Section_Title: productForm.getAttribute("data-section-title"),
          Product_Name : productForm.getAttribute("data-product-title"), 
          Quantity : document.querySelector(".quantity__input").value || 1,
          Offer_Price : productForm.getAttribute("data-offer-price"),
          MRP : productForm.getAttribute("data-mrp"),
          Previous_Cart_Value : previousCartValue ,
          Current_Cart_Value : cartValue ,
          Product_Image : productForm.getAttribute("data-product-image"),
          Variant_id : productForm.getAttribute("data-variantid"),
          Product_id : productForm.getAttribute("data-productid"),
          clevertap : clevertapData
        });

        clevertap.event.push("cart_updated",{
          Section_Title: productForm.getAttribute("data-section-title"),
          Product_Name : productForm.getAttribute("data-product-title"), 
          Quantity : document.querySelector(".quantity__input").value || 1,
          Offer_Price : productForm.getAttribute("data-offer-price"),
          MRP : productForm.getAttribute("data-mrp"),
          Previous_Cart_Value : previousCartValue ,
          Current_Cart_Value : cartValueNumeric ,
          Product_Image : productForm.getAttribute("data-product-image"),
          Variant_id : productForm.getAttribute("data-variantid"),
          Product_id : productForm.getAttribute("data-productid")
        });

        if (productForm.getAttribute("data-quiz-product")) {
          let quizClevertapData = {
            PDP_Name: productForm.getAttribute("data-product-title"),
            Price : productForm.getAttribute("data-offer-price"), 
            Qty : 1,
            PDP_Link : productForm.getAttribute("data-product-link"),
            Old_cart_Value : previousCartValue ,
            New_Cart_value : cartValue ,
            Variant_ID : productForm.getAttribute("data-variantid"),
            Variant_SKU : productForm.getAttribute("data-productid"),
            PDP_Image : productForm.getAttribute("data-product-image")
          }
  
          dataLayer.push({
            event: "Quiz_Suggested_Add_To_Cart",
            PDP_Name: productForm.getAttribute("data-product-title"),
            Price : productForm.getAttribute("data-offer-price"), 
            Qty : 1,
            PDP_Link : productForm.getAttribute("data-product-link"),
            Old_cart_Value : previousCartValue ,
            New_Cart_value : cartValue ,
            Variant_ID : productForm.getAttribute("data-variantid"),
            Variant_SKU : productForm.getAttribute("data-productid"),
            PDP_Image : productForm.getAttribute("data-product-image"),
            clevertap : quizClevertapData
          });
        }

        if (this.dataset.sectionTitle === "Product_Slider_Add_To_Cart") {
          let clevertapData = {
            Product_Name : this.getAttribute("data-product-title") || '',
            Qty : 1,
            SKU: this.getAttribute("data-skuId") || ''
          }

          dataLayer.push({
            event: "Product_Slider_Add_To_Cart",
            Product_Name : this.getAttribute("data-product-title") || '',
            Qty : 1,
            SKU: this.getAttribute("data-skuId") || '',
            clevertap : clevertapData
          });
        }
      }
    }
  );
}
